import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { leiRegExp } from 'enums/regExp';

// TODO
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _modulo = (divident: any, divisor: number) => {
    let cDivident = '';
    let cRest = '';

    for (const i in divident) {
        if (!Object.prototype.hasOwnProperty.call(divident, i)) continue;
        const cChar = divident[i];
        const cOperator = cRest + '' + cDivident + '' + cChar;

        if (parseInt(cOperator) < divisor) cDivident += '' + cChar;
        else {
            cRest = String(parseInt(cOperator) % divisor);
            cDivident = '';

            if (cRest == '0') cRest = '';
        }
    }
    cRest += '' + cDivident;

    if (cRest == '') cRest = '0';

    return parseInt(cRest);
};

export const validateLEI = (vstupLei: string) => {
    // 0 - OK
    // 1 - E: nezadano
    // 2 - E: chybna syntaxe
    // 3 - E: chybna kontrolka
    if (!vstupLei) return 1; // nezadano
    if (!leiRegExp.test(vstupLei)) return 2; // chybna syntaxe

    // transformace znaku
    let sb = '';
    for (let i = 0; i < vstupLei.length; i++) {
        const chr = vstupLei.charAt(i);
        const num =
            chr >= 'A' && chr <= 'Z'
                ? chr.charCodeAt(0) - 'A'.charCodeAt(0) + 10
                : chr.charCodeAt(0) - '0'.charCodeAt(0);
        sb += num;
    }

    // kontrolni cislice
    if (_modulo(sb, 97) != 1) return 3; // chybna kontrolka

    return 0;
};

/* funkce modulo pro velká čísla, kvůli validaci LEI (snippet ze stackOwerflow) */

export const leiValidation = (callback?: (value: string) => void) => [
    () => ({
        async validator(_rule: RuleObject, value: string) {
            if (!value || validateLEI(value) === 0) {
                Promise.resolve();
                return callback && callback(value);
            }
            return Promise.reject(<TranslateText>CHECK_LEI_MATKASLEI_NEPLATNE_LEI</TranslateText>);
        }
    })
];

export default leiValidation;
